import { useApolloClient } from '@apollo/react-hooks';
import { subtract } from 'lodash/fp';
import { PENDING_TERM_AND_CONDITION_COUNT } from '../GraphQL/Queries';
import logger from '../logger';

const usePendingTermConditionCountCache = (schoolId, eventId) => {
  const client = useApolloClient();
  const updatePendingTermConditionCountCache = (user, action) => {
    try {
      const data = client.readQuery({
        query: PENDING_TERM_AND_CONDITION_COUNT,
        variables: {
          eventId: parseInt(eventId, 10),
          schoolId: parseInt(schoolId, 10),
        },
      });
      const { fetchPendingTermAndCondition } = data;
      let response = 0;
      if (action === 'remove') {
        response = subtract(fetchPendingTermAndCondition, 1);
      }
      client.writeQuery({
        query: PENDING_TERM_AND_CONDITION_COUNT,
        data: {
          fetchPendingTermAndCondition: response,
        },
        variables: {
          eventId: parseInt(eventId, 10),
          schoolId: parseInt(schoolId, 10),
        },
      });
    } catch (e_) {
      logger('Update not needed!');
    }
  };

  return updatePendingTermConditionCountCache;
};

export default usePendingTermConditionCountCache;
